export default __webpack_public_path__ + "static/media/payment-summary-icon.321bddbf.svg";